import { render, staticRenderFns } from "./tab-plano-form.vue?vue&type=template&id=959b80fe&"
import script from "./tab-plano-form.vue?vue&type=script&lang=js&"
export * from "./tab-plano-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports